import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
/* --- import Components ----*/
import { ProgramSubtitle } from '../elements';
/* --- import Style ----*/
import { mediaQueries } from 'src/style/breakpoints';

const Projects = () => {
  return (
    <div
      css={{
        display: 'flex',
        marginTop: 80,
        flexDirection: 'column',
        gap: 40,
        [mediaQueries.desktopUp]: {
          flexDirection: 'row',
          alignItems: 'stretch',
          justifyContent: 'stretch',
          gap: 20,
        },
        [mediaQueries.phoneOnly]: {
          gap: 0,
        },
      }}
    >
      <section
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 40,
          [mediaQueries.desktopUp]: {
            flex: 2,
            justifyContent: 'space-around',
            gap: 0,
          },
          [mediaQueries.phoneOnly]: {
            gap: 0,
          },
        }}
      >
        <ProgramSubtitle
          css={{
            textAlign: 'center',
          }}
        >
          Vous aurez réalisé d’incroyables projets&nbsp;!
        </ProgramSubtitle>
        <StaticImage
          src="../../../data/images/project_logos.png"
          alt="logos des sites internet réalisés par les étudiants du Reacteur"
          css={{
            width: '70%',
            height: '250px',
            [mediaQueries.desktopUp]: {
              width: '100%',
              height: '190px',
            },
            [mediaQueries.phoneOnly]: {
              width: '80%',
              height: '190px',
            },
          }}
          objectFit="contain"
        />
      </section>
      <StaticImage
        src="../../../data/images/project_screens2.png"
        alt="écrans des sites internet réalisés par les étudiants du Reacteur"
        css={{
          width: '100%',
          height: '350px',
          [mediaQueries.desktopUp]: {
            height: '280px',
            minHeight: 'none',
            flex: 3,
          },
          [mediaQueries.phoneOnly]: {
            width: '100%',
            height: '220px',
          },
        }}
        objectFit="contain"
      />
    </div>
  );
};

export default Projects;
